<template>
    <v-menu v-model="openInput" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                hide-details="auto"
                :label="label"
                v-model="model_"
                :style="`margin: 10px 0 0; ${styleInput}`"
                :class="'dateField ' + classInput"
                :append-icon="'far fa-calendar'"
                v-bind="attrs" 
                v-on="on"
                outlined
                readonly
                dense
                :persistent-hint="message ? true : false"
                :hint="message"
            ></v-text-field>
        </template>

        <v-card height="auto" width="300" :class="`text-input-date ${classCard}`">
            <div>
                <v-date-picker
                    v-model="model_"
                    @change="saveDate"
                    :header-date-format="$datePicker.formatDateHeader"
                    :title-date-format="$datePicker.formatTitleDate"
                    :weekday-format="$datePicker.formatWeekday"
                    :month-format="$datePicker.formatMonth"
                ></v-date-picker>
            </div>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    props: {
        label:String, 
        model: [ String, Date ], 
        styleInput:String, 
        color:String, 
        classInput:String, 
        classCard:String, 
        typeString:String,
        message:String
    },
    data () {
        return {
            openInput: false,
            model_: null
        };
    },
    computed: {
        model_string: function () {
            return this.model_;
        }
    },
    methods: {
        saveDate (value) {
            this.$emit("saveDate", value, this.model_);
            this.openInput = false;
        }
    },
    created () {
        this.model_ = this.model;
    }
}
</script>

<style lang="scss">
.text-input-date {padding: 2%;}
.dateField {
    .v-messages__message {padding-left: .5rem;}
    .v-input__control .v-text-field__details {min-width: calc(100% / 12) !important;}
}
</style>